import { IconProps } from "./IconProps";

export const TypeModeIcon24 = ({ className }: IconProps) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.55556 6.44444H16.4444M12 6.44444V17.5556M7.33333 22H16.6667C18.5336 22 19.4669 22 20.18 21.6367C20.8072 21.3171 21.3171 20.8072 21.6367 20.18C22 19.4669 22 18.5336 22 16.6667V7.33333C22 5.46649 22 4.53307 21.6367 3.82003C21.3171 3.19282 20.8072 2.68289 20.18 2.36331C19.4669 2 18.5336 2 16.6667 2H7.33333C5.46649 2 4.53307 2 3.82003 2.36331C3.19282 2.68289 2.68289 3.19282 2.36331 3.82003C2 4.53307 2 5.46649 2 7.33333V16.6667C2 18.5336 2 19.4669 2.36331 20.18C2.68289 20.8072 3.19282 21.3171 3.82003 21.6367C4.53307 22 5.46649 22 7.33333 22Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
